<ng-content></ng-content>

<div class="version-info" *ngIf="isVersionVisible">
  Copyright &copy; 2021 Auvious. Version {{ version }}
</div>

<div appThemableLogo *ngIf="!isMobile" class="logo-text"></div>
